import { ContextualTipsTrigger } from "@babackapp/ui/components/contextual-tips";
import { Position } from "@xyflow/react";
import { Webhook } from "lucide-react";
import { useTranslation } from "react-i18next";
import { BaseHandle } from "../../components/base-handle";
import { BaseNode, BaseNodeContent } from "../../components/base-node";
import { useNodeData } from "../../hooks/use-node-data";
import { getWebhookHost } from "./webhook-url";

export const WEBHOOK_ACTION_NODE_WIDTH = 250;
export const WEBHOOK_ACTION_NODE_HEIGHT_ESTIMATION = 130;

type LiveData = {
  actionType: string;
  config?: { url?: string };
};

export function WebhookActionNodeEditor({ id }: { id: string }) {
  const { t } = useTranslation("trackoffice");
  const liveData = useNodeData<LiveData>(id);
  const host = getWebhookHost(liveData?.config?.url);

  return (
    <ContextualTipsTrigger
      tips={[
        {
          id: "workflow-node-webhook",
          Icon: Webhook,
          title: t(
            "workflowsEditor.tips.workflowNodeWebhook.title",
            "This is a webhook action node",
          ),
          description: t(
            "workflowsEditor.tips.workflowNodeWebhook.desc",
            "This node sends the event to a URL of your choice, to connect Baback to your own tools.",
          ),
        },
      ]}
    >
      <BaseNode nodeId={id} style={{ position: "relative" }}>
        <BaseNodeContent>
          <div className="flex flex-col gap-2 w-full">
            <div className="flex flex-col">
              <span className="text-xs text-muted-foreground">
                {t("workflowsEditor.webhookNode.action", "Action")}
              </span>
              <span className="text-xs mt-1 font-semibold">
                {t("workflowsEditor.webhookNode.title", "Send webhook")}
              </span>
              <span className="text-xs mt-1 text-muted-foreground truncate">
                {host ??
                  t("workflowsEditor.webhookNode.noUrl", "No URL configured")}
              </span>
            </div>
          </div>
          <BaseHandle type="target" position={Position.Left} />
          <BaseHandle
            type="source"
            position={Position.Right}
            style={{ top: "50%", transform: "translateY(-50%)" }}
          />
        </BaseNodeContent>
      </BaseNode>
    </ContextualTipsTrigger>
  );
}
